import React from "react";
import { Link } from "react-router-dom";
import "../Portfolio.css";

const apps = [
  {
    name: "La Loteria - Mexican Bingo App",
    path: "/privacy/la-loteria",
  },
];

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <Link to="/" className="privacy-back-link">
          &larr; Back to Portfolio
        </Link>
        <h1 className="privacy-title">
          Privacy Policy
          <span className="privacy-title-dot">.</span>
        </h1>
        <p className="privacy-subtitle">
          Select an app below to view its privacy policy.
        </p>
        <div className="privacy-app-list">
          {apps.map((app, index) => (
            <Link key={index} to={app.path} className="privacy-app-card">
              <span className="privacy-app-name">{app.name}</span>
              <span className="privacy-app-arrow">&rarr;</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
